import React, { FC, useState } from 'react'
import { Tabs } from 'antd'
import { H2, TabsContainer, Toast } from '../../shared/components'
import Profile from './Profile'
import Invitations from './Invitations'
import Notifications from './Notifications'
import { useAuth } from '../../shared/contexts/authContext'
import { InvitationsStrings } from '../../shared/strings/InvitationsContent'
import { NotificationStrings } from '../../shared/strings/NotificationContent'
import { MyProfileStrings } from '../../shared/strings/MyProfileContent'
import { InvitationsTabTitle, StyledNotificationIcon, PageTitleRow } from './Styles'
import { NotificationAPI } from '../../shared/api/notifications'
import { useQuery } from 'react-query'

const { TabPane } = Tabs

const MyProfile: FC = () => {
  const { hasNewInvitation } = useAuth()

  const [isErrorVisible, setIsErrorVisible] = useState(false)
  const [errorDetail, setErrorDetail] = useState<string | undefined>()

  const [isSuccessVisible, setIsSuccessVisible] = useState(false)
  const [successMessage, setSuccessMessage] = useState<string | undefined>()

  const subscriptionData = useQuery(NotificationAPI.queryNames.GET_SUBSCRIPTION, () =>
    NotificationAPI.getSubscription()
  )
  const subscriptionTypes = useQuery(NotificationAPI.queryNames.GET_ALL, () => NotificationAPI.getSubscriptionType())
  return (
    <>
      <PageTitleRow>
        <H2>{MyProfileStrings.myProfile}</H2>
        <Toast
          isVisible={isErrorVisible}
          position="absolute"
          text={errorDetail}
          onDismiss={() => setIsErrorVisible(false)}
          type="error"
        />
        <Toast
          isVisible={isSuccessVisible}
          position="absolute"
          text={successMessage}
          onDismiss={() => setIsSuccessVisible(false)}
          type="success"
        />
      </PageTitleRow>
      <TabsContainer id="my-profile-tabs-js" defaultActiveKey="1" centered={false}>
        <TabPane key="1" tab={MyProfileStrings.profileDetails}>
          <Profile />
        </TabPane>
        <TabPane
          key="2"
          tab={
            <InvitationsTabTitle>
              {InvitationsStrings.myInvitations} {hasNewInvitation() && <StyledNotificationIcon />}
            </InvitationsTabTitle>
          }
        >
          <Invitations
            setIsErrorVisible={setIsErrorVisible}
            setErrorDetail={setErrorDetail}
            setIsSuccessVisible={setIsSuccessVisible}
            setSuccessMessage={setSuccessMessage}
          />
        </TabPane>
        <TabPane key="3" tab={NotificationStrings.notifiaction}>
          <Notifications subscription={subscriptionData.data} subscriptionTypes={subscriptionTypes.data} />
        </TabPane>
      </TabsContainer>
    </>
  )
}

export default MyProfile
